import React, { useState } from 'react';
import { PlusCircle, FileText, Clock } from 'lucide-react';
import SimpleReceipt from './SimpleReceipt';
import ReceiptHistory from './ReceiptHistory';
import PendingBilling from './PendingBilling';
import './BillingTabs.css';

const BillingTabs = () => {
    const [activeTab, setActiveTab] = useState('pending');
    const [selectedPatientStudies, setSelectedPatientStudies] = useState(null);
    const [receiptKey, setReceiptKey] = useState(0);

    const tabs = [
        { id: 'pending', label: 'Por Cobrar', icon: Clock },
        { id: 'new', label: 'Nuevo Recibo', icon: PlusCircle },
        { id: 'history', label: 'Historial', icon: FileText }
    ];

    // When a patient's studies are selected from pending, switch to new receipt tab
    const handleSelectStudies = (patientGroup) => {
        setSelectedPatientStudies(patientGroup);
        setReceiptKey(prev => prev + 1); // Force fresh mount
        setActiveTab('new');
    };

    const handleTabChange = (tabId) => {
        if (tabId !== 'new') {
            // Clear prefilled data when leaving the receipt tab
            setSelectedPatientStudies(null);
            setReceiptKey(prev => prev + 1); // Next visit will be a fresh form
        }
        setActiveTab(tabId);
    };

    return (
        <div className="billing-tabs-container">
            <div className="billing-tabs-header">
                <div className="tabs-nav">
                    {tabs.map((tab) => {
                        const IconComponent = tab.icon;
                        return (
                            <button
                                key={tab.id}
                                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                                onClick={() => handleTabChange(tab.id)}
                            >
                                <IconComponent size={18} />
                                <span>{tab.label}</span>
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="billing-tabs-content">
                {activeTab === 'pending' && <PendingBilling onSelectStudies={handleSelectStudies} />}
                {activeTab === 'new' && <SimpleReceipt key={receiptKey} prefilledPatientStudies={selectedPatientStudies} onClear={() => setSelectedPatientStudies(null)} />}
                {activeTab === 'history' && <ReceiptHistory />}
            </div>
        </div>
    );
};

export default BillingTabs;


